import {
  Home,
  Sparkles,
  Settings2,
  PackageCheck,
  PartyPopper,
  Building2,
  UserRound,
  Droplets,
  ArrowRight,
} from "lucide-react";
import { SERVICES } from "@/data/content";
import { StarDash } from "@/components/StarDash";

const ICONS = {
  "Regular Cleaning": Home,
  "Complete Cleaning": Sparkles,
  "Customised Cleaning": Settings2,
  "Move-in / Move-out": PackageCheck,
  "Festive Cleaning": PartyPopper,
  "Exterior Cleaning": Building2,
  "Part-time Maids": UserRound,
  "Stain Removal": Droplets,
};

const Services = () => {
  const scrollContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 sm:py-32 bg-[#c63027] text-[#fbf3e6] overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-8 sm:gap-10 items-end mb-10 sm:mb-12">
          <div className="lg:col-span-7 reveal">
            <div className="font-sans-body text-[11px] font-bold uppercase tracking-[0.32em] text-[#fbf3e6]/80">
              ★ Our Services
            </div>
            <h2 className="font-display mt-5 text-4xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] italic">
              What Can We <br /> Clean for You?
            </h2>
          </div>
          <p className="lg:col-span-5 text-base sm:text-lg leading-relaxed text-[#fbf3e6]/85 reveal">
            From weekly tidying of your house, apartment, office and more — to
            commercial contracts, deep cleans and post-renovation sweeps. Eight
            specialities, one trusted team that shapes the service around your
            space.
          </p>
        </div>

        {/* Pill cards grid */}
        <div className="grid sm:grid-cols-2 gap-3 sm:gap-4" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.title] || Sparkles;
            return (
              <button
                key={s.title}
                onClick={scrollContact}
                data-testid={`service-card-${i + 1}`}
                className="group reveal text-left bg-[#fbf3e6] hover:bg-white rounded-full px-6 py-5 flex items-center justify-between gap-4 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
                style={{ transitionDelay: `${i * 30}ms` }}
              >
                <div className="flex items-center gap-4 min-w-0">
                  <span className="shrink-0 size-11 grid place-items-center rounded-full bg-[#c63027]/10 text-[#c63027]">
                    <Icon className="size-5" />
                  </span>
                  <div className="min-w-0">
                    <div className="font-display font-bold text-lg sm:text-xl text-[#c63027] tracking-tight truncate">
                      {s.title}
                    </div>
                    <div className="text-xs sm:text-sm text-[#6b5a4a] truncate">
                      {s.blurb}
                    </div>
                  </div>
                </div>
                <ArrowRight className="shrink-0 size-4 text-[#c63027] opacity-60 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </button>
            );
          })}
        </div>

        <StarDash className="mt-16 mb-8" color="rgba(251,243,230,0.55)" />

        <div className="text-center">
          <button
            onClick={scrollContact}
            data-testid="services-cta-btn"
            className="pill-btn inline-flex items-center gap-2 h-14 px-8 bg-[#fbf3e6] hover:bg-white text-[#c63027] text-base transition-colors shadow"
          >
            ★ Call 019-731 8121 — Free Quote
            <ArrowRight className="size-5" />
          </button>
          <p className="mt-4 font-italic-serif text-[#fbf3e6]/85">
            Don't see your exact need? We customise — just ask.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
